import React, { useEffect, useMemo, useState } from "react";
import { MarketersAnalysis } from "../../pages";
import { MarketersController } from "../../controllers";
import { object, string } from "yup";
import { toJS } from "mobx";
import { marketersStore } from "../../stores";
import { observer } from "mobx-react";

const filterByData = [
  { value: "Type", key: "type" },
  { value: "Marketer", key: "id" },
  { value: "Business-Partner", key: "id" },
];

const MarketersAnalysisContainer = () => {
  const [marketerTable, setMarketerTable] = useState(true);
  const [businessPartnerTable, setBusinessPartnerTable] = useState(false);
  const [todoModal, setTodoModal] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilterParam, setSelectedFilterParam] = useState(
    filterByData[0]
  );
  const [filterTitle, setFilterTitle] = useState("");

  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterParams, setFilterParams] = useState("");

  useEffect(() => {
    const fetchMarketersAnalysis = async () => {
      await MarketersController.getMarketersAnalysis();
    };
    fetchMarketersAnalysis();
  }, []);

  const marketersTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { data } = MarketersController.useGetMarketersBusinesses(
    marketersTableQuery,
    filterQuery,
    searchQuery
  );

  const goToMarketerTable = () => {
    setMarketerTable(true);
    setBusinessPartnerTable(false);
  };

  const goToBusinessPartnerTable = () => {
    setBusinessPartnerTable(true);
    setMarketerTable(false);
  };

  const closeModal = () => {
    setTodoModal(false);
  };

  const validationSchema = () => {
    return object({
      selectedFilter: string().required("Please select a filter option"),
      type: string().when("selectedFilter", {
        is: "type",
        then: string().required("Select a Type"),
      }),
      businessPartner: string().when("selectedFilter", {
        is: "businessPartner",
        then: string().required("Select a Business Partner"),
      }),
      marketer: string().when("selectedFilter", {
        is: "marketer",
        then: string().required("Select a Marketer"),
      }),
    });
  };

  const closeFilter = () => {
    setShowFilter(false);
  };

  const onSubmit = async (values) => {
    setShowFilter(false);
    let queryParams = {};
    if (selectedFilterParam.value === "Type") {
      queryParams.type = values.type;
    }
    if (selectedFilterParam.value === "Marketer") {
      queryParams.marketer = values.marketer;
      setFilterParams(values.marketer);
    }
    if (selectedFilterParam.value === "Business-Partner") {
      queryParams.businessPartner = values.businessPartner;
      setFilterParams(values.businessPartner);
    }
    setFilterTitle(values.filterTitle);

    await MarketersController.getMarketersAnalysis(queryParams);
    setShowFilter(false);
  };

  return (
    <MarketersAnalysis
      marketerTable={marketerTable}
      businessPartnerTable={businessPartnerTable}
      goToBusinessPartnerTable={goToBusinessPartnerTable}
      goToMarketerTable={goToMarketerTable}
      marketerAnalysis={toJS(marketersStore.marketerAnalysis)}
      validationSchema={validationSchema}
      showFilter={showFilter}
      setShowFilter={setShowFilter}
      onSubmit={onSubmit}
      filterByData={filterByData}
      selectedFilterParam={selectedFilterParam}
      setSelectedFilterParam={setSelectedFilterParam}
      filterTitle={filterTitle}
      closeFilter={closeFilter}
      data={data}
      closeModal={closeModal}
      todoModal={todoModal}
      setTodoModal={setTodoModal}
      filterParams={filterParams}
    />
  );
};

export default observer(MarketersAnalysisContainer);
